import { API_URL, PREFIX } from "../components/common/Config";

export const fetchPromotionsList = async ({
  status = "active",
  page = 1,
  pageSize = 20,
  search = "",
  sortBy = "start_date",
  sortOrder = "desc",
} = {}) => {
  try {
    const token = localStorage.getItem("token");
    const accessToken = localStorage.getItem("accessToken") || PREFIX;

    let url = `${API_URL}/api/promotions?status=${status}&page=${page}&page_size=${pageSize}&sort_by=${sortBy}&sort_order=${sortOrder}`;

    if (search && search.trim() !== "") {
      url += `&search=${encodeURIComponent(search.trim())}`;
    }

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching promotions:", error);
    throw error;
  }
};

export const fetchProductsList = async ({
  search = "",
  category = "",
  brand = "",
  page = 1,
  pageSize = 20,
  producttype = "",
  pack = "",
  box = "",
} = {}) => {
  try {
    const accessToken = localStorage.getItem("accessToken") || PREFIX;

    const params = new URLSearchParams({
      page: page.toString(),
      page_size: pageSize.toString(),
    });

    if (search) params.append("search", search);
    if (category && category !== "All") params.append("category", category);
    if (brand && brand !== "All") params.append("brand", brand);
    if (producttype) params.append("producttype", producttype);
    if (pack && pack > 0) params.append("pack", pack.toString());
    if (box) params.append("box", box.toString());

    const url = `${API_URL}/api/products?${params.toString()}`;

    const response = await fetch(url, {
      method: "GET",
      mode: "cors",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching products:", error);
    throw error;
  }
};

export const fetchCategories = async () => {
  try {
    const accessToken = localStorage.getItem("accessToken") || PREFIX;

    const url = `${API_URL}/api/categories`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching categories:", error);
    throw error;
  }
};

export const fetchBrands = async () => {
  try {
    const accessToken = localStorage.getItem("accessToken") || PREFIX;

    const url = `${API_URL}/api/brands`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching brands:", error);
    throw error;
  }
};

export const fetchPromotionChannels = async () => {
  try {
    const accessToken = localStorage.getItem("accessToken") || PREFIX;

    const url = `${API_URL}/api/channels`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching promotion channels:", error);
    throw error;
  }
};

export const createPromotion = async (promotionData) => {
  try {
    const accessToken = localStorage.getItem("accessToken") || PREFIX;
    const token = localStorage.getItem("token");

    const url = `${API_URL}/api/promotions`;

    const response = await fetch(url, {
      method: "POST",
      mode: "cors",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(promotionData),
    });

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        message:
          data.messages?.message ||
          data.message ||
          `HTTP error! status: ${response.status}`,
        errors: data.messages?.errors || data.errors || {},
        status: response.status,
      };
    }

    return data;
  } catch (error) {
    console.error("Error creating promotion:", error);
    return {
      success: false,
      message: error.message || "Network error occurred",
      errors: {},
    };
  }
};

export const updatePromotionStatus = async (promotionId, status) => {
  try {
    const accessToken = localStorage.getItem("accessToken") || PREFIX;
    const user_id = localStorage.getItem("userId");
    const token = localStorage.getItem("token");

    const url = `${API_URL}/api/promotions_updateStatus/${promotionId}/status`;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ status, user_id }),
    });

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        message: data.message || `HTTP error! status: ${response.status}`,
        errors: data.errors || {},
        status: response.status,
      };
    }

    return data;
  } catch (error) {
    console.error("Error updating promotion status:", error);
    return {
      success: false,
      message: error.message || "Network error occurred",
      errors: {},
    };
  }
};

export const fetchPromotionById = async (promotionId) => {
  try {
    const accessToken = localStorage.getItem("accessToken") || PREFIX;
    const token = localStorage.getItem("token");

    const url = `${API_URL}/api/promotions/${promotionId}`;

    const response = await fetch(url, {
      method: "GET",
     
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching promotion:", error);
    throw error;
  }
};

export const updatePromotion = async (promotionData) => {
  try {
    const accessToken = localStorage.getItem("accessToken") || PREFIX;
    const token = localStorage.getItem("token");

    const url = `${API_URL}/api/create-similar-promo`;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(promotionData),
    });

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        message:
          data.messages?.message ||
          data.message ||
          `HTTP error! status: ${response.status}`,
        errors: data.messages?.errors || data.errors || {},
        status: response.status,
      };
    }

    return data;
  } catch (error) {
    console.error("Error updating promotion:", error);
    return {
      success: false,
      message: error.message || "Network error occurred",
      errors: {},
    };
  }
};

export const validatePromotionCode = async (promotionCode) => {
  try {
    const accessToken = localStorage.getItem("accessToken") || PREFIX;
    const token = localStorage.getItem("token");

    const url = `${API_URL}/api/promotions/validate-code`;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ promotion_code: promotionCode }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error validating promotion code:", error);
    throw error;
  }
};

export default {
  fetchPromotionsList,
  fetchProductsList,
  fetchCategories,
  fetchBrands,
  createPromotion,
  validatePromotionCode,
};
